/* eslint-disable react-hooks/exhaustive-deps */

import { Button, Col, Container, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useParams } from "react-router-dom";
import BtnLoader from "../../BtnLoader";
import DeleteAllUrls from "../Modal/DeleteAllUrls";
import DeleteUrls from "../Modal/DeleteUrls";
import { Link } from "react-router-dom";
import ReactTost from "../../ReactTost";
import UserAddDocument from "../Modal/UserAddDocument";
import UserDocDelete from "../Modal/UserDocDelete";
import UserDocEdit from "../Modal/UserDocEdit";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const UserChatBotSources = (props) => {
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [urlLoading, setUrlLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedUrlCheckboxes, setSelectedUrlCheckboxes] = useState([]);
  const [urlId, setUrlId] = useState();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const botId = props.botData.id;
  const user = localStorage.getItem("id");
  const [addModalShow, setAddModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteURLModalShow, setDeleteURLModalShow] = useState(false);
  const [urls, setUrls] = useState("");
  const [getUrls, setGetUrls] = useState([]);
  const [urlStatus, setUrlStatus] = useState({});
  const [urlEmpty, setUrlEmpty] = useState(false);
  const [allUrl, setAllUrl] = useState([]);
  const [addUploadModel, setUploadModel] = useState(false);
  const [docList, setDocList] = useState([]);
  const [isDoc, setIsDoc] = useState(true);
  const [docId, setDocId] = useState("");
  const [getDoc, setGetDoc] = useState([]);
  const [checkWebUrls, setCheckWebUrls] = useState(false);
  const [selectLabel, setSelectLabel] = useState("Select All");
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [monthly, setMontly] = useState(true);
  const [weekly, setWeekly] = useState(false);
  const [none, setNone] = useState(false);
  const [durationId, setDurationId] = useState("");
  const [urlSuccess, setUrlSuccess] = useState(false);
  const [saveUrl, setSaveUrl] = useState(false);
  const [totalSubUrls, setTotalSubUrls] = useState();
  const { t } = useTranslation();
  const [urlValue, setUrlValue] = useState();
  const [allUrls, setAllUrls] = useState([]);
  const { id } = useParams();
  const [urlTextarea, setUrlTextarea] = useState(false);
  const [maxUrlCount, setMaxUrlCount] = useState(false);
  const [totalLength, setTotalLength] = useState(0);
  const [urlError, setUrlError] = useState(false);
  const [docIndex, setDocIndex] = useState(0);

  // Fetching all the scanned urls and all documnet
  function getAllDoc() {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/user_doc?id=${user}&bot=${botId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data.usersDoc)
        setGetDoc(response.data.usersDoc);
        setGetUrls(response.data.usersUrls);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
  }
  const downloadFile = async (id, fileName, type) => {
    try {
      const response = await axios.get(`${API_URL}/download`, {
        params: {
          docId: id, // replace with actual document ID
        },
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.${type}`); //or any other extension
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading file:', error);
      //setDownloadError('Error downloading file');
    }
  };


  //getting data of saved document
  useEffect(() => {
    if (props.docData) {
      setDocList(props.docData);
    }
    axios
      .get(`${API_URL}/${API_VERSION}/bot/${botId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const receivedCheckboxIds = response.data.docs;
        setSelectedCheckboxes(receivedCheckboxIds);
        setSelectedUrlCheckboxes(receivedCheckboxIds);
        console.log(selectedUrlCheckboxes)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_URL, API_VERSION, props.docData, botId]);

  //updating the ids and checkboxes of documents
  function updateDoc(event) {
    const checkboxId = event.target.value;
    if (event.target.checked) {

      setSelectedCheckboxes((prevSelected) => [...prevSelected, checkboxId]);
    } else {

      setSelectedUrlCheckboxes((prevSelected) =>
        prevSelected.filter((removeID) => removeID !== checkboxId)
      );
      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((removeID) => removeID !== checkboxId)
      );
    }
  }

  //saving documents
  function updateDocument(e) {

    e.preventDefault();
    setSaveUrl(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/bot/${botId}`,
        {
          docs: [...selectedCheckboxes, ...selectedUrlCheckboxes],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(async (response) => {
        await indexingDocument()
          .then(() => {
            setMessage(t("Documents save successfully."));
            setType("Success");
          })
          .catch(() => {
            setType("Danger");
            setMessage(t("Documents not save to gpt."));
          });
        setShowAlert(true);
        setSaveUrl(false);
      })
      .catch(() => {
        setSaveUrl(false);
        setType("Danger");
        setMessage(t("Something went wrong."));
        setShowAlert(true);
      });
  }

  async function indexingDocument() {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot/index/${botId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((_response) => {
          resolve(true);
        })
        .catch((_error) => {
          reject(false);
        });
    });
  }


  useEffect(() => {
    if (isDoc && user) {
      setIsDoc(false);
      getAllDoc();
    }
  }, [isDoc, user]);

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />

      <section className="usertabs">
        <Container>
          <Row className="justify-content-center">
            <Col md={12}>
              <Tabs
                onSelect={(index) => setDocIndex(index)}
                selectedIndex={docIndex}
              >
                <TabList className="chat_bot_source d-flex align-items-center justify-content-start">
                  <Tab>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-list-check"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="#05204a"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3.5 5.5l1.5 1.5l2.5 -2.5" />
                      <path d="M3.5 11.5l1.5 1.5l2.5 -2.5" />
                      <path d="M3.5 17.5l1.5 1.5l2.5 -2.5" />
                      <path d="M11 6l9 0" />
                      <path d="M11 12l9 0" />
                      <path d="M11 18l9 0" />
                    </svg>{" "}
                    {t("Choose files")}
                  </Tab>
                  <Tab>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-file-text"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="#05204a"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                      <path d="M9 9l1 0" />
                      <path d="M9 13l6 0" />
                      <path d="M9 17l6 0" />
                    </svg>
                    {t("My Files")}
                  </Tab>
                </TabList>
                <TabPanel>
                  <div className="option_box">
                    <Row>
                      <Col md={12}>
                        {getDoc.length <= 0 ? (
                          <div className="d-flex align-items-center justify-content-end flex-wrap mb-4">
                            <Link
                              className="userbutton"
                              onClick={() => setUploadModel(true)}
                            >
                              <i className="fa-solid fa-circle-plus"></i>
                              {t("New Document")}
                            </Link>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
                            <h4>{t("Choose Document")}</h4>
                            <Link
                              className="userbutton w-auto"
                              onClick={() => setUploadModel(true)}
                            >
                              <i className="fa-solid fa-circle-plus"></i>
                              {t("New Document")}
                            </Link>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="list_doc">
                          {getDoc &&
                            getDoc.map((doc, index) => (
                              <Form.Group
                                className="mb-3"
                                //controlId={index}
                                key={doc.id}
                              >
                                <Form.Check
                                  type="checkbox"
                                  id={doc.id}
                                  label={doc.name}
                                  checked={selectedCheckboxes.includes(doc.id)}
                                  value={doc.id}
                                  onChange={(e) => updateDoc(e, doc.id)}
                                />
                              </Form.Group>
                            ))}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col md={12}>
                          <div className="d-flex justify-content-end">
                            <button
                              type="submit"
                              onClick={updateDocument}
                              className="userbutton"
                              disabled={saveLoading}
                            >
                              {saveLoading ? <BtnLoader /> : t("Save")}
                            </button>
                          </div>
                      </Col>
                    </Row>
                  </div>
                </TabPanel>

                <TabPanel>
                  <div className="option_box">
                    <Row>
                      <Col md={12}>
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          <Link
                            className="userbutton"
                            onClick={() => setUploadModel(true)}
                          >
                            <i className="fa-solid fa-circle-plus"></i>
                            {t("New Document")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <div className="new_doc_tab">
                        {getDoc &&
                          getDoc.map((doc, index) => {
                            let iconClass = "";
                            switch (doc.type) {
                              case "pdf":
                                iconClass = "fa-file-pdf";
                                break;
                              case "doc":
                              case "docx":
                                iconClass = "fa-file-word";
                                break;
                              case "csv":
                                iconClass = "fa-file-csv";
                                break;
                              case "xls":
                              case "xlsx":
                                iconClass = "fa-file-excel";
                                break;
                              default:
                                iconClass = "fa-file";
                                break;
                            }

                            let mb = doc.size > 1024 ? "MB" : "KB";
                            let sizeinMB =
                              doc.size > 1024
                                ? Math.round(doc.size / 1024)
                                : Math.round(doc.size);

                            return doc.type !== "web" && doc.type !== "txt" ? (
                              <Col lg={12} md={12} className="mb-2" key={index}>
                                <div className="new_doc_body">
                                  <div className="w-100 d-flex justify-content-center resonsive_box">
                                    <div className="imgbox">
                                      <i className={`fa-solid fa-fw ${iconClass}`}></i>
                                    </div>
                                    <div className="infobox">
                                      <div className="info">
                                        <span>{doc.name}</span>
                                      </div>
                                      <div className="small_info">
                                        <div className="dot"></div>
                                        <div className="info_size">
                                          <span className="size">
                                            {sizeinMB}
                                            {mb}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="action_box">
                                    <Link
                                      className="sm_button"
                                      onClick={() => downloadFile(doc.id, doc.name, doc.type)}
                                    >
                                      <i className="fa-solid fa-download"></i>
                                    </Link>
                                    <Link
                                      className="sm_button"
                                      onClick={() => {
                                        setDocId(doc.id);
                                        setAddModalShow(true);
                                      }}
                                    >
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </Link>
                                    <Button
                                      className="sm_button"
                                      variant=""
                                      onClick={() => {
                                        setDocId(doc.id);
                                        setDeleteModalShow(true);
                                      }}
                                    >
                                      <i className="fa-solid fa-trash-can"></i>
                                    </Button>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            );
                          })}
                      </div>
                    </Row>

                  </div>
                </TabPanel>
              </Tabs>
            </Col>
          </Row>
        </Container>

        <UserAddDocument
          show={addUploadModel}
          doc={getAllDoc}
          onHide={() => {
            setUploadModel(false);
          }}
        />

        <UserDocEdit
          show={addModalShow}
          id={docId}
          doc={getAllDoc}
          onHide={() => {
            setAddModalShow(false);
          }}
        />

        <UserDocDelete
          show={deleteModalShow}
          id={docId}
          onHide={() => {
            setDeleteModalShow(false);
            setIsDoc(true);
          }}
        />
      </section>
    </>
  );
};
export default UserChatBotSources;
